import { render } from "./MyButton.vue?vue&type=template&id=01af461a&scoped=true"
import script from "./MyButton.vue?vue&type=script&lang=js"
export * from "./MyButton.vue?vue&type=script&lang=js"

import "./MyButton.vue?vue&type=style&index=0&id=01af461a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01af461a"]])

export default __exports__